module.exports = __webpack_public_path__ + "static/media/s3.51492c2b.webp";